<template>
  <div class="records-list">
    <Loading v-if="loading" :background-color="'#ffffff'" :opacity="0.4"/>
    <div v-else-if="expiringPoints.length === 0" class="empty">暫無即將到期點數</div>
    <PointCard
      v-else
      v-for="item in expiringPoints"
      :key="item.id"
      :title="getModuleConfig('member_card_section.points_name') || '點數'"
      :date="item.date"
      :date-label="item.date?'到期日期':'永久有效'"
      :point-need-text="item.point"
      :show-type-info="false"
    />
  </div>
</template>

<script>
import pointApi from "@/apis/liff/v2/point";
import { format } from "date-fns";
import Loading from "@/components/Page/Liff/Shared/Loading";
import PointCard from "@/components/Page/Liff/Point/PointCard";

export default {
  components: {
    Loading,
    PointCard,
  },
  props: {
    eventCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      expiringPointsResponse: null,
      loading: false,
    };
  },
  computed: {
    expiringPoints() {
      return (this.expiringPointsResponse || [])
        .map((item, index) => ({
          id: `expiring-${index}`,
          point: parseInt(item.point || 0).toLocaleString("en-US"),
          date: item.expired_at?format(new Date(item.expired_at), "yyyy/MM/dd"):'',
        })).sort((a, b) => {
          // 1. If both are empty, they are equal
          if (a.date === b.date) return 0;
          
          // 2. If 'a' is empty, move it to the end (return positive)
          if (a.date === '') return 1;
          
          // 3. If 'b' is empty, move 'a' to the front (return negative)
          if (b.date === '') return -1;
          
          // 4. Otherwise, compare strings normally for ascending order
          return a.date.localeCompare(b.date);
        });
    },
  },
  mounted() {
    this.fetchExpiringPoints();
  },
  methods: {
    async fetchExpiringPoints() {
      this.loading = true;
      try {
        this.expiringPointsResponse = await pointApi.getAllExpiringPoints(this.eventCode);
      } catch (error) {
        console.error("Failed to fetch expiring points:", error);
      } finally {
        this.loading = false;
      }
    },
    getModuleConfig(key) {
      console.log(this.$store.getters["liffModule/getConfig"]("member_center", key));
      console.log(key);

      return this.$store.getters["liffModule/getConfig"]("member_center", key);
    },
  },
};
</script>

<style lang="scss" scoped>
.records-list {
  padding: 12px;
  padding-bottom: 0;
  background: #fff;
}

.loading, .empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--liff-secondary_text_color);
  font-size: 14px;
}
</style>
